module.exports = require('./create')({
  'http': require('http'),
  'https': require('https')
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/follow-redirects/index.js
 ** module id = 120
 ** module chunks = 0
 **/